import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/Shell";
import { Plus, Warehouse } from "lucide-react";

export default function Warehouses() {
  const [items, setItems] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name:"", location:"", address:"", incharge_name:"", contact:"" });
  const [err, setErr] = useState("");

  const load = () => api.get("/warehouses").then(r => setItems(r.data));
  useEffect(() => { load().catch(e=>setErr(formatApiError(e))); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/warehouses", form); setShowCreate(false); setForm({ name:"", location:"", address:"", incharge_name:"", contact:"" }); load(); }
    catch (e2) { setErr(formatApiError(e2)); }
  };

  return (
    <div className="p-4 md:p-8" data-testid="warehouses-page">
      <PageHeader title="Warehouses" subtitle="Physical locations holding stock."
        action={<button onClick={()=>setShowCreate(s=>!s)} data-testid="add-wh-btn" className="inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold text-sm py-2 px-4 rounded-md"><Plus size={14}/> Add Warehouse</button>}
      />
      {showCreate && (
        <Card className="p-5 mb-6" data-testid="wh-form">
          <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input required placeholder="Name" value={form.name} onChange={e=>setForm(f=>({...f, name:e.target.value}))} className="inp" data-testid="wh-name" />
            <input required placeholder="Location/City" value={form.location} onChange={e=>setForm(f=>({...f, location:e.target.value}))} className="inp" data-testid="wh-location" />
            <input placeholder="In-charge Name" value={form.incharge_name} onChange={e=>setForm(f=>({...f, incharge_name:e.target.value}))} className="inp" />
            <input placeholder="Contact" value={form.contact} onChange={e=>setForm(f=>({...f, contact:e.target.value}))} className="inp" />
            <input placeholder="Address" value={form.address} onChange={e=>setForm(f=>({...f, address:e.target.value}))} className="inp md:col-span-2" />
            <button type="submit" data-testid="wh-save-btn" className="md:col-span-3 bg-[#F97316] hover:bg-[#EA580C] text-white font-semibold text-sm py-2 px-4 rounded-md">Save</button>
          </form>
        </Card>
      )}
      {err && <div className="text-rose-600 text-sm mb-3">{err}</div>}
      {items.length === 0 ? <EmptyState title="No warehouses" icon={Warehouse} /> :
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(w => (
            <Card key={w.id} className="p-5">
              <div className="flex items-start justify-between">
                <div>
                  <div className="font-display font-bold text-lg">{w.name}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">{w.location}</div>
                </div>
                <Warehouse size={18} className="text-[#F97316]" />
              </div>
              <div className="mt-4 space-y-1 text-xs text-zinc-600">
                <div>{w.address || "—"}</div>
                <div><span className="font-semibold">In-charge:</span> {w.incharge_name || "—"}</div>
                <div><span className="font-semibold">Contact:</span> {w.contact || "—"}</div>
              </div>
            </Card>
          ))}
        </div>
      }
      <style>{`.inp { width:100%; border:1px solid #E4E4E7; background:#fff; border-radius:.375rem; padding:.5rem .75rem; font-size:.85rem; outline:none } .inp:focus { box-shadow: 0 0 0 2px #F97316; border-color: transparent }`}</style>
    </div>
  );
}
